const CARDISLE_GREETING_CARD = 'CARDISLE_GREETING_CARD';

export { CARDISLE_GREETING_CARD };
